module.exports = __webpack_public_path__ + "static/media/016-nepal.648c93fe.svg";